import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import { initI18N } from "i18n";

import { IApplicationState } from "store";

import Root from "app-shell/Root/Root";

import configureStore from "./app/store/configureStore";
import { Spinner } from "component-library";
import "./index.css";

initI18N(["casting", "performer", "agent"]);

//  https://stackoverflow.com/questions/8788802/prevent-safari-loading-from-cache-when-back-button-is-clicked
window.onpageshow = function (event: PageTransitionEvent) {
  if (event.persisted) {
    document.body.style.display = "none";
    window.location.reload();
  }
};

const store = configureStore({} as IApplicationState);
const container = document.getElementById("root");

if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);

root.render(
  <Suspense fallback={<Spinner />}>
    <Root store={store} />
  </Suspense>
);
